export const ApiFetchStatus = {
  UNINITIALIZED: 'uninitialized',
  PENDING: 'pending',
  REJECTED: 'rejected',
  FULFILLED: 'fulfilled',
};
